<template>
  <div class="switch-discount">
    <button
      class="switch-discount__value percent"
      title="В процентах"
      type="button"
      v-bind:class="{ selected: $options.discountInPercent === value }"
      v-bind:disabled="disabled"
      v-on:click="emitSelected($options.discountInPercent)"
    />
    <button
      class="switch-discount__value ruble"
      title="В тенге"
      type="button"
      v-bind:class="{ selected: $options.discountInKopeck === value }"
      v-bind:disabled="disabled"
      v-on:click="emitSelected($options.discountInKopeck)"
    />
  </div>
</template>

<script>
export const DISCOUNT_IN_KOPECK = 'kopeck';
export const DISCOUNT_IN_PERCENT = 'percent';
export const DISCOUNT_MIXED = 'mixed';

/**
 * @description Переключатель типа скидки.
 * @type {Vue}
 */
export default {
  discountInKopeck: DISCOUNT_IN_KOPECK,
  discountInPercent: DISCOUNT_IN_PERCENT,
  methods: {
    /**
     * @description Отправить событие выбора.
     * @param {string} value
     * @returns {void}
     */
    emitSelected(value) {
      this.$emit('input', value);
    },
  },
  props: {
    /**
     * @description Деактивированн.
     * @type {boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Значение.
     * @type {string}
     */
    value: {
      required: true,
      type: String,
      validator: (value) => [
        DISCOUNT_IN_PERCENT,
        DISCOUNT_IN_KOPECK,
        DISCOUNT_MIXED,
      ].includes(value),
    },
  },
};
</script>

<style  lang="scss">

.switch-discount {
  display: flex;
  &__value {
    height: 1.5rem;
    width: 1.5rem;
    padding: 5px;
    background-color: #EAEFF3;
    background-size: 70%;
    background-position: center;
    border: 1px solid #C2CFE0;
    &:disabled {
      cursor: inherit !important;
      pointer-events: none;
    }
    &.selected {
      background-color: #0489E0;
      border: 1px solid #0489E0;
    }
    &.percent {
      background-image: url("@/assets/img/switch/percent-grey.svg");
      border-radius: 2px 0 0 2px;
      &:hover {
        border: 1px solid #0489E0;
      }
      &.selected {
        background-image: url("@/assets/img/switch/percent-while.svg");
      }
    }
    &.ruble {
      background-image: url("@/assets/img/switch/tenge-grey.svg");
      border-radius: 0 2px 2px 0;
      &:hover {
        border: 1px solid #0489E0;
      }
      &.selected {
        background-image: url("@/assets/img/switch/tenge-white.svg");
      }
    }
  }
}
.switch {
  display: flex;
  &__value {
    &.selected {
      background-color: var(--action-color);
      color: white;
    }
  }
}
</style>
